// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Экран 8 «Диалоги» (утверждён 28.10.2026). */
.dl-wrap {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
/* Сводка */
.dl-summary {
  padding: 0;
  overflow: hidden;
}
.dl-sum-row {
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 12px 16px;
  flex-wrap: wrap;
}
.dl-stat {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--v2-muted);
}
.dl-stat b {
  color: var(--v2-primary);
  font-size: 16px;
}
.dl-ua {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #fde7c2;
  background: var(--v2-orange-bg);
  color: #c2410c;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}
.dl-ua b {
  font-size: 15px;
}
.dl-ua.is-on {
  border-color: #c2410c;
}
.dl-chart-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: none;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  color: var(--v2-primary);
}

/* Список + переписка */
.dl-split {
  display: grid;
  grid-template-columns: minmax(300px, 360px) minmax(0, 1fr);
  gap: 14px;
  height: max(520px, calc(100vh - 140px));
}
.dl-list,
.dl-conv {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  padding: 0;
}
.dl-list-head {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.dl-check {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  cursor: pointer;
}
.dl-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  height: 26px;
  padding: 0 6px 0 10px;
  border-radius: 999px;
  background: var(--v2-blue-bg);
  color: #1d4fa8;
  font-size: 12px;
  font-weight: 600;
}
.dl-chip button {
  border: 0;
  background: none;
  cursor: pointer;
  color: inherit;
  font-size: 11px;
}
.dl-list-hint {
  padding: 6px 12px;
  background: var(--v2-bg);
  border-top: 1px solid var(--v2-border-soft);
  border-bottom: 1px solid var(--v2-border-soft);
}
.dl-items {
  flex: 1;
  overflow-y: auto;
}
.dl-item {
  width: 100%;
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 12px;
  border: 0;
  border-bottom: 1px solid var(--v2-border-soft);
  background: #fff;
  text-align: left;
  font: inherit;
  cursor: pointer;
  color: inherit;
}
.dl-item:hover,
.dl-item.is-sel {
  background: var(--v2-bg);
}
.dl-item-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.dl-item-top {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}
.dl-item-top b {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dl-item-text {
  font-size: 13px;
  color: var(--v2-text-2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dl-ua-tag {
  color: #c2410c;
  font-weight: 600;
}
.dl-conv-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--v2-border-soft);
}
.v2-btn.dl-back {
  display: none;
}
.dl-msgs {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: #fafafa;
}
.dl-msg {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 78%;
}
.dl-msg.is-in {
  align-self: flex-end;
  align-items: flex-end;
}
.dl-msg.is-out {
  align-self: flex-start;
}
.dl-bubble {
  padding: 10px 12px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
}
.dl-msg.is-in .dl-bubble {
  background: var(--v2-primary);
  color: #fff;
}
.dl-msg.is-out .dl-bubble {
  background: #fff;
  border: 1px solid var(--v2-border);
}
.dl-msg.is-out .dl-bubble.is-na {
  background: var(--v2-orange-bg);
  border-color: #fde7c2;
}
.dl-na-link {
  font-size: 12px;
  font-weight: 600;
  color: #c2410c;
}
.dl-conv-foot {
  padding: 10px 16px;
  border-top: 1px solid var(--v2-border-soft);
}

/* Узко: список или переписка (с кнопкой «← Все диалоги»). */
@media (max-width: 1080px) {
  .dl-split {
    grid-template-columns: minmax(0, 1fr);
  }
  .dl-split > .dl-conv {
    display: none;
  }
  .dl-split.is-conv > .dl-conv {
    display: flex;
  }
  .dl-split.is-conv > .dl-list {
    display: none;
  }
  .dl-split .v2-btn.dl-back {
    display: inline-flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dialogs/dialogs.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA,WAAW;AACX;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,uCAAuC;AACzC;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,2CAA2C;EAC3C,8CAA8C;AAChD;AACA;EACE,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,8CAA8C;EAC9C,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,8CAA8C;AAChD;AACA;EACE,aAAa;AACf;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA,4DAA4D;AAC5D;EACE;IACE,qCAAqC;EACvC;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;AACF","sourcesContent":["/* Экран 8 «Диалоги» (утверждён 28.10.2026). */\n.dl-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n/* Сводка */\n.dl-summary {\n  padding: 0;\n  overflow: hidden;\n}\n.dl-sum-row {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  padding: 12px 16px;\n  flex-wrap: wrap;\n}\n.dl-stat {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--v2-muted);\n}\n.dl-stat b {\n  color: var(--v2-primary);\n  font-size: 16px;\n}\n.dl-ua {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 30px;\n  padding: 0 12px;\n  border-radius: 8px;\n  border: 1px solid #fde7c2;\n  background: var(--v2-orange-bg);\n  color: #c2410c;\n  font: inherit;\n  font-size: 13px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.dl-ua b {\n  font-size: 15px;\n}\n.dl-ua.is-on {\n  border-color: #c2410c;\n}\n.dl-chart-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 0;\n  background: none;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  color: var(--v2-primary);\n}\n\n/* Список + переписка */\n.dl-split {\n  display: grid;\n  grid-template-columns: minmax(300px, 360px) minmax(0, 1fr);\n  gap: 14px;\n  height: max(520px, calc(100vh - 140px));\n}\n.dl-list,\n.dl-conv {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n}\n.dl-list-head {\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.dl-check {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  cursor: pointer;\n}\n.dl-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  align-self: flex-start;\n  height: 26px;\n  padding: 0 6px 0 10px;\n  border-radius: 999px;\n  background: var(--v2-blue-bg);\n  color: #1d4fa8;\n  font-size: 12px;\n  font-weight: 600;\n}\n.dl-chip button {\n  border: 0;\n  background: none;\n  cursor: pointer;\n  color: inherit;\n  font-size: 11px;\n}\n.dl-list-hint {\n  padding: 6px 12px;\n  background: var(--v2-bg);\n  border-top: 1px solid var(--v2-border-soft);\n  border-bottom: 1px solid var(--v2-border-soft);\n}\n.dl-items {\n  flex: 1;\n  overflow-y: auto;\n}\n.dl-item {\n  width: 100%;\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  padding: 12px;\n  border: 0;\n  border-bottom: 1px solid var(--v2-border-soft);\n  background: #fff;\n  text-align: left;\n  font: inherit;\n  cursor: pointer;\n  color: inherit;\n}\n.dl-item:hover,\n.dl-item.is-sel {\n  background: var(--v2-bg);\n}\n.dl-item-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.dl-item-top {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n}\n.dl-item-top b {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.dl-item-text {\n  font-size: 13px;\n  color: var(--v2-text-2);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.dl-ua-tag {\n  color: #c2410c;\n  font-weight: 600;\n}\n.dl-conv-head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--v2-border-soft);\n}\n.v2-btn.dl-back {\n  display: none;\n}\n.dl-msgs {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  background: #fafafa;\n}\n.dl-msg {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  max-width: 78%;\n}\n.dl-msg.is-in {\n  align-self: flex-end;\n  align-items: flex-end;\n}\n.dl-msg.is-out {\n  align-self: flex-start;\n}\n.dl-bubble {\n  padding: 10px 12px;\n  border-radius: 12px;\n  font-size: 14px;\n  line-height: 1.45;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n.dl-msg.is-in .dl-bubble {\n  background: var(--v2-primary);\n  color: #fff;\n}\n.dl-msg.is-out .dl-bubble {\n  background: #fff;\n  border: 1px solid var(--v2-border);\n}\n.dl-msg.is-out .dl-bubble.is-na {\n  background: var(--v2-orange-bg);\n  border-color: #fde7c2;\n}\n.dl-na-link {\n  font-size: 12px;\n  font-weight: 600;\n  color: #c2410c;\n}\n.dl-conv-foot {\n  padding: 10px 16px;\n  border-top: 1px solid var(--v2-border-soft);\n}\n\n/* Узко: список или переписка (с кнопкой «← Все диалоги»). */\n@media (max-width: 1080px) {\n  .dl-split {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .dl-split > .dl-conv {\n    display: none;\n  }\n  .dl-split.is-conv > .dl-conv {\n    display: flex;\n  }\n  .dl-split.is-conv > .dl-list {\n    display: none;\n  }\n  .dl-split .v2-btn.dl-back {\n    display: inline-flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
